import MailResponse from './MailResponse';

export default MailResponse;
